import React from 'react';
import PropTypes from 'prop-types';
import { TrackedLink } from '../TrackedLink';
import { addPetClicked } from './events';

export const AddPupButton = ({
  href,
  fullWidth = false,
  variant,
  verticalPadding,
  horizontalPadding,
  minWidth = 122,
  text,
}) => {
  const addIcon = {
    size: '18px',
    iconName: 'plus',
    alt: 'add icon',
    color: 'hero.plum',
    position: 'before',
  };

  return (
    <TrackedLink
      href={href}
      icon={addIcon}
      fullWidth={fullWidth}
      analyticsEvent={addPetClicked()}
      variant={variant}
      verticalPadding={verticalPadding}
      horizontalPadding={horizontalPadding}
      minWidth={minWidth}
    >
      {text}
    </TrackedLink>
  );
};

AddPupButton.displayName = 'AddPupButton';
AddPupButton.propTypes = {
  href: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string.isRequired,
  verticalPadding: PropTypes.number.isRequired,
  horizontalPadding: PropTypes.number.isRequired,
  minWidth: PropTypes.number,
  text: PropTypes.string.isRequired,
};
